import { render } from "./richEditor.vue?vue&type=template&id=77331fd4&scoped=true"
import script from "./richEditor.vue?vue&type=script&lang=js"
export * from "./richEditor.vue?vue&type=script&lang=js"

import "./richEditor.vue?vue&type=style&index=0&id=77331fd4&scoped=true&lang=css"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77331fd4"]])

export default __exports__